import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const BrandUpdatePage = lazy(() => import('../views/update/BrandUpdatePage'));

export function BrandUpdatePageLazy() {
	return (
		<PageSuspense>
			<BrandUpdatePage />
		</PageSuspense>
	);
}
